var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 px-8"},[(_vm.message)?_c('div',{staticClass:"my-2 p-2 w-full block rounded select-none hover:bg-red-300 bg-red-400 text-neutral-700",class:_vm.customClass},[_vm._v(" Error: "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }